import styled from 'styled-components'
/*
 * Anchor tag with no styling. This is meant to be used for external links.
 */
const NoStyleAnchor = styled.a`
    text-decoration: none;
    color: inherit;
    outline: 0;
    cursor: auto;
`

export default NoStyleAnchor
